export default __webpack_public_path__ + "static/media/client-8.96d2b9d6.png";